export default __webpack_public_path__ + "9a184d8fd9b021df4bcf42bdaa970fcb.svg";